import React from 'react';

import Classes from './HeroImage.scss';

type TProps = {
  imageUrl: string;
  children?: React.ReactNode;
  withOverlay?: boolean;
};

const HeroHeader = ({ children, withOverlay = true, imageUrl }: TProps) => (
  <div className={Classes.root} style={{ backgroundImage: `url(${imageUrl})` }}>
    {withOverlay && <div className={Classes.overlay} />}
    {children && <div className={Classes.content}>{children}</div>}
  </div>
);

export default HeroHeader;
